import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, input, output } from "@angular/core";

import { PageInfo } from "../../../apis/networkdashboard/graphql/graphql";
import { PaginationDefault } from "./components/default/default";
import { PaginationNumbered } from "./components/numbered/numbered";

export enum PaginationStyle {
  Default,
  Numbered,
}

@Component({
  selector: "pagination",
  templateUrl: "pagination.html",
  styleUrl: "pagination.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, PaginationDefault, PaginationNumbered],
})
export class Pagination {
  public pageInfo = input.required<PageInfo>();
  protected itemsPerPage = input<number>(10);
  public paginationStyle = input<PaginationStyle>(PaginationStyle.Default);

  protected paginationChanged = output<number>();
  protected pageSizeChanged = output<number>();

  protected isDefault = computed(() => this.paginationStyle() === PaginationStyle.Default);
  protected isNumbered = computed(() => this.paginationStyle() === PaginationStyle.Numbered);

  protected firstItem = computed(() => Number(this.pageInfo().startCursor ?? -1) + 1);
  protected lastItem = computed(() => Number(this.pageInfo().endCursor ?? -1) + 1);
  // ponytail: keeps existing backend workaround — hasNextPage/totalItems are unreliable from API
  protected totalItems = computed(() => (this.pageInfo().totalItems ?? 0) - 1);
  protected hasNextPage = computed(() => (this.pageInfo().endCursor ?? -2) + 2 === (this.pageInfo().totalItems ?? 0));

  protected nextPage() {
    if (this.pageInfo().hasNextPage) {
      const endCursor = (this.pageInfo().endCursor ?? 0) + 1;
      this.paginationChanged.emit(endCursor);
    }
  }

  protected prevPage() {
    if (this.pageInfo().hasPreviousPage) {
      const startCursor = (this.pageInfo().startCursor ?? 0) - this.itemsPerPage();
      this.paginationChanged.emit(Math.max(startCursor, 0));
    }
  }

  protected toPage(v: number) {
    this.paginationChanged.emit(v);
  }

  protected onPageSizeChanged(v: number) {
    this.pageSizeChanged.emit(v);
  }
}
